<template>
  <div class="import_assistant">
    <div v-if="$route.path === '/importassistant/importlist'" class="right">
      <div class="operation">
        <div class="operationSearch">
          <i @click="drawerOpen" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan}">&#xe624;</i>
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span
            class="colorG">{{ pageTotal }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
          <i v-show="isSearch" @click="clearSearchData" class="el-icon-close"
             style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @sort-change='sortChange'
          style="width: auto;"
          v-loading="loading"
          :default-sort="{prop: 'addDate', order: 'descending'}"
          height="100%">
          <el-table-column
            prop="enumImportType"
            :label="$t('LanguageLib.IMPORT_TYPE')"
            sortable="custom"
            min-width="140">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top">
                <span slot="content" type="enumImportType">{{$commonfun.ImportType(scope.row.enumImportType)}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="enumImportType">{{$commonfun.ImportType(scope.row.enumImportType)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileName"
            :label="$t('LanguageLib.IMPORT_FILE_NAME')"
            sortable="custom"
            min-width="170">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top" class="code">
                <span slot="content" type="fileName">{{scope.row.fileName}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="fileName">{{scope.row.fileName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.IMPORT_PROGRESS')"
            min-width="140">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top">
                <span slot="content" type="fileTotalCount">{{scope.row.fileCreatCount + scope.row.fileUpdateCount + scope.row.fileFailCount}}/{{scope.row.fileTotalCount}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="fileTotalCount">{{scope.row.fileCreatCount + scope.row.fileUpdateCount + scope.row.fileFailCount}}/{{scope.row.fileTotalCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileCreatCount"
            :label="$t('LanguageLib.CREATE_DATA')"
            sortable="custom"
            min-width="130">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top">
                <span slot="content" type="fileCreatCount">{{scope.row.fileCreatCount}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="fileCreatCount">{{scope.row.fileCreatCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileUpdateCount"
            :label="$t('LanguageLib.UPDATE_DATA')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top">
                <span slot="content" type="fileUpdateCount">{{scope.row.fileUpdateCount}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="fileUpdateCount">{{scope.row.fileUpdateCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileFailCount"
            :label="$t('LanguageLib.UNSUCCESSFUL_DATA')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top">
                <span slot="content" type="fileFailCount">{{scope.row.fileFailCount}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="fileFailCount">{{scope.row.fileFailCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="addDate"
            :label="$t('LanguageLib.IMPORT_TIME')"
            sortable="custom"
            min-width="200">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top">
                <span slot="content" type="addDate">{{$commonfun.formatDate(scope.row.addDate, '1')}}</span>
                <span ref="toolTipItem"
                      style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                      type="addDate">{{$commonfun.formatDate(scope.row.addDate, '1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('LanguageLib.OPERATOR')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top">
                <span
                  v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))"
                  slot="content" type="userName">{{scope.row.userName}}</span>
                <span
                  v-if="!$commonfun.iswx(scope.row.userName) || !JSON.parse($commonfun.localStorage.getitem('qyuser'))"
                  ref="toolTipItem"
                  style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                  type="userName">{{scope.row.userName}}</span>
                <span
                  v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))"
                  slot="content" type="userName">
                  <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                </span>
                <span
                  v-if="$commonfun.iswx(scope.row.userName) && JSON.parse($commonfun.localStorage.getitem('qyuser'))"
                  ref="toolTipItem"
                  style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                  type="userName">
                  <ww-open-data slot="content" type="userName" :openid="scope.row.userName.slice(3)"></ww-open-data>
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="70">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="downLoad(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.DOWNLOAD_FEEDBACK_FORM')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe610;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <el-drawer
      v-if="$route.path === '/importassistant/importlist'"
      :visible.sync="drawer"
      :show-close="true"
      :modal="false"
      :wrapperClosable="false"
      size="420px"
      :with-header="false">
      <div style="overflow: hidden">
        <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
        <el-button @click="drawerClose" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;"
                   type="text"><i class="el-icon-close"></i></el-button>
      </div>
      <p class="drawerText">{{$t('LanguageLib.IMPORT_TYPE')}}</p>
      <el-select style="width: 100%;" filterable v-model="ImportTypeStatus" clearable
                 :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
        <el-option
          v-for="item in ImportTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <p class="drawerText">{{$t('LanguageLib.IMPORT_STATUS')}}</p>
      <el-select style="width: 100%;" v-model="ImportStatusStatus" clearable
                 :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
        <el-option
          v-for="item in ImportStatusList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div style="position: absolute;bottom: 68px;right: 20px;">
        <el-button @click="resetSearchData" style="height: 30px;padding: 7px 20px;" class="resetBtn">
          {{$t('LanguageLib.RESET')}}
        </el-button>
        <el-button @click="searchOrgList" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">
          {{$t('LanguageLib.SEARCH_FOR')}}
        </el-button>
      </div>
    </el-drawer>
    <router-view v-if="$route.path !== '/importassistant/importlist'"></router-view>
  </div>
</template>

<script>
import importassistantApi from '../../api/importassistant'

export default {
  name: 'importlist',
  props: {
    msg: String
  },
  data () {
    return {
      ImportTypeList: [{
        value: 1000,
        label: this.$t('LanguageLib.STAFF_MANAGEMENT') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 1010,
        label: this.$t('LanguageLib.QYUSER') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 2000,
        label: this.$t('LanguageLib.STORE_MANAGEMENT') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 3000,
        label: this.$t('LanguageLib.SHOP_EQUIPMENT') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 4000,
        label: this.$t('LanguageLib.DISPLAY_BROCHURE') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 5000,
        label: this.$t('LanguageLib.TEST_QUESTION') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 6000,
        label: this.$t('LanguageLib.MAINTENANCE_CLASSIFICATION_IMPORT')
      }, {
        value: 7000,
        label: this.$t('LanguageLib.MAINTENANCE_FAULT_IMPORT')
      }, {
        value: 8000,
        label: this.$t('LanguageLib.ITEM_CLASSIFICATION_IMPORT')
      }, {
        value: 9000,
        label: this.$t('LanguageLib.ITEM_INFORMATION') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 10000,
        label: this.$t('LanguageLib.SHOP_PROPS_IMPORT')
      }, {
        value: 11000,
        label: this.$t('LanguageLib.ROLES') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 12000,
        label: this.$t('LanguageLib.DISPLAY_BROCHURE_RELATIONSHIP') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 13000,
        label: this.$t('LanguageLib.ITEM_INVENTORY') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 14000,
        label: this.$t('LanguageLib.USER_JOB_INFORMATION_IMPORT')
      }, {
        value: 15000,
        label: this.$t('LanguageLib.KPI_SALES_TARGET') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 16000,
        label: this.$t('LanguageLib.SHOP_TOUR_TEMPLATE') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 21000,
        label: this.$t('LanguageLib.ORGANIZATION1') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 22000,
        label: this.$t('LanguageLib.MNT_QUESTION') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 26000,
        label: this.$t('LanguageLib.STORE_LONG_FORM') + this.$t('LanguageLib.IMPORT')
      }, {
        value: 31000,
        label: this.$t('LanguageLib.BINDING_QY_DEPARTMENT') + this.$t('LanguageLib.IMPORT')
      }], // 导入类型列表
      ImportStatusList: [{
        value: 1,
        label: this.$t('LanguageLib.SUCCESS')
      }, {
        value: 0,
        label: this.$t('LanguageLib.FAILURE')
      }], // 用户类型列表
      seen: false, // 鼠标移入是否显示背景色
      current: 0, // 当前要显示背景色的数据
      loading: true, // loading状态
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      isSearch: false, // 是否为搜索状态
      shaixuan: false, // 漏斗图是否高亮
      drawer: false, // 抽屉框默认收起
      searchOrgName: '', // 抽屉框组织名称
      searchDescContent: '', // 抽屉框备注内容
      searchOrgTypeList: [], // 抽屉框组织类型列表
      checkedSelectData: '', // 抽屉框组织类型选中
      getImportInfoFun: (pageIndex, pageSize, searchVal, sort, isAsc, ImportType, ImportStatus) => {
        this.loading = true
        importassistantApi.GetImportInfo('post', '/ImportInfo/page', {
          pageIndex,
          pageSize,
          searchVal,
          sort,
          isAsc,
          ImportType,
          ImportStatus
        })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 0, // 排序字段 默认添加时间
      sortOrder: false, // 排序方式逆序：desc正序asc
      ImportType: -1, // 导入分类
      ImportStatus: -1, // 导入状态
      ImportTypeStatus: '', // 导入分类
      ImportStatusStatus: '', // 导入状态
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder
        newQuery.ImportType = this.ImportType
        newQuery.ImportStatus = this.ImportStatus
        newQuery.NoRefresh = true
        this.$router.push({
          path,
          query: newQuery
        })
      }
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort * 1
      this.sortOrder = JSON.parse(this.$route.query.sortOrder)
      this.ImportType = this.$route.query.ImportType * 1
      this.ImportTypeStatus = this.$route.query.ImportType * 1 === -1 ? '' : this.$route.query.ImportType * 1
      this.ImportStatus = this.$route.query.ImportStatus * 1
      this.ImportStatusStatus = this.$route.query.ImportStatus * 1 === -1 ? '' : this.$route.query.ImportStatus * 1
    } else {
    }
    if (this.ImportTypeStatus === '' && this.ImportStatusStatus === '') {
      this.isSearch = false
      this.shaixuan = false
    } else {
      this.isSearch = true
      this.shaixuan = true
    }
    this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
  },
  methods: {
    // 列表排序
    sortChange (column) {
      switch (column.prop) {
        case 'enumImportType':
          this.sort = 1
          break
        case 'fileCreatCount':
          this.sort = 2
          break
        case 'fileUpdateCount':
          this.sort = 3
          break
        case 'fileFailCount':
          this.sort = 4
          break
        case 'userName':
          this.sort = 5
          break
        case 'fileName':
          this.sort = 6
          break
        case 'addDate':
          this.sort = 0
          break
        default:
          this.sort = 0
      }
      if (column.order === 'ascending') {
        // 升序
        column.order = 'asc'
        this.sortOrder = true
      } else if (column.order === 'descending') {
        // 降序
        column.order = 'desc'
        this.sortOrder = false
      } else {
        column.order = 'asc'
        this.sortOrder = false
      }
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.updataRouteQuery()
      this.currentPage = 1
      this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
    },
    // 过滤点击
    drawerOpen () {
      this.drawer = true
      this.shaixuan = true
    },
    // 过滤关闭
    drawerClose () {
      this.drawer = false
      this.shaixuan = false
    },
    // 点击搜索
    searchOrgList () {
      this.drawer = false
      this.isSearch = true
      this.ImportType = this.ImportTypeStatus === '' ? -1 : this.ImportTypeStatus
      this.ImportStatus = this.ImportStatusStatus === '' ? -1 : this.ImportStatusStatus
      this.currentPage = 1
      this.updataRouteQuery()
      this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
    },
    // 清空搜索数据
    resetSearchData () {
      this.ImportTypeStatus = ''
      this.ImportStatusStatus = ''
    },
    // 清除搜索状态
    clearSearchData () {
      this.shaixuan = false
      this.isSearch = false
      this.ImportTypeStatus = ''
      this.ImportStatusStatus = ''
      this.ImportType = this.ImportTypeStatus === '' ? -1 : this.ImportTypeStatus
      this.ImportStatus = this.ImportStatusStatus === '' ? -1 : this.ImportStatusStatus
      this.currentPage = 1
      this.updataRouteQuery()
      this.getImportInfoFun(this.currentPage, this.pageSize, this.searchText, this.sort, this.sortOrder, this.ImportType, this.ImportStatus)
    },
    // 下载文件
    downLoad (data, index, tableData) {
      window.open(data.filePath, '_self')
    }
  },
  watch: {}
}
</script>

<style lang="scss">
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .import_assistant {
    width: 100%;
    height: 100%;
  }

  .import_assistant .left {
    background: #fff;
    width: 20%;
    float: left;
    height: 100%;
    border-right: 1px solid #f2f2f2;

    .treeBox {
      height: calc(100% - 50px);
      overflow: auto;
      width: 100%;
    }

    .fifter {
      padding: 10px 0 10px 6%;
      line-height: 30px;

      .el-input {
        width: 60%;
      }

      .el-button--text {
        margin-left: 2.5%;
        padding: 2% 0;
        width: 20%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .import_assistant .right {
    width: 100%;
    height: 100%;

    .operation {
      background: #fff;
      height: 30px;
      padding: 10px 0 10px 20px;
      border-bottom: 1px solid #f2f2f2;
      border-top: 1px solid #f2f2f2;

      .operationBtn {
        width: auto;
        display: inline-block;
        float: left;
        position: relative;

        .el-button {
          height: 30px;
          padding: 7px 20px;
        }

        .BatchSetting {
          background: #fff;
          color: #666666;
          position: absolute;
          left: 0;
          top: 30px;
          width: 100px;
          font-size: 14px;
          text-align: center;
          box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
          border-radius: 2px;
          z-index: 99;

          li {
            line-height: 30px;
            cursor: pointer;
          }
        }

        .exportType {
          background: #fff;
          color: #666666;
          position: absolute;
          right: 0;
          top: 30px;
          min-width: 100px;
          font-size: 14px;
          text-align: center;
          box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
          border-radius: 2px;
          z-index: 99;

          li {
            line-height: 30px;
            cursor: pointer;
          }
        }
      }

      .operationSearch {
        float: right;
        padding-right: 51px;
        position: relative;

        .shaixuan {
          color: #999999;
          height: 15px;
          width: 15px;
          position: relative;
          top: 2px;
          margin-left: 10px;
          margin-right: 10px;
          font-weight: 600;
        }

        .shaixuan1 {
          color: #3BC6B9;
        }

        .el-input {
          width: 160px;

          .el-input__inner {
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }

        .el-icon-search {
          line-height: 30px;
        }
      }
    }

    .tableParent {
      height: calc(100% - 98px);
    }

    .el-pagination {
      padding: 8px 15px 5px;
      height: 35px;
      background: #fff;
    }
  }

  .import_assistant .drawerTitle {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(77, 77, 77, 1);
    line-height: 25px;
    margin-bottom: 20px;
  }

  .import_assistant .drawerText {
    height: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(77, 77, 77, 1);
    line-height: 16px;
    margin-bottom: 5px;
  }

  .cell {
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .el-button--default {
    border: 1px solid #3BC6B9;
    color: #3BC6B9;
  }

  .el-button--primary {
    background-color: #3BC6B9;
    color: #fff;
    border: none;
    margin-left: 10px;
  }

  .el-button--primary:hover {
    background-color: #3BC6B9;
    color: #fff;
    border: none;
  }

  /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #3BC6B9 !important;
    border-color: #3BC6B9 !important;
  }*/
  // 对于树组件配置特有的css
  .el-tree-node > .el-tree-node__children {
    overflow: unset;
  }

  .el-tree-node__content {
    height: 48px;
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #F6F6F6
  }

  // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
  //   color: #3BC6B9 !important;
  // }
  // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
  //   color: #3BC6B9 !important;
  // }
  // 更改表格的滚动条样式
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
    background: #E1E1E1;
  }

  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 5px;
    background: #fff;
  }

  // 抽屉组件样式修改
  .el-drawer.rtl {
    outline: none;
  }

  .el-drawer__wrapper {
    top: 172px;
    bottom: 18px;
    /*  right: 20px;*/
  }

  section.el-drawer__body {
    padding: 20px;

    .el-input {
      margin-bottom: 15px;
    }
  }

  .el-drawer__container {
    outline: none;
  }

  .colorG {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(59, 198, 185, 1);
    line-height: 20px;
  }

  .el-table .descending .sort-caret.descending {
  }

  .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #3BC6B9;
  }

  .el-pager li.active {
    color: #3BC6B9;
  }

  .el-table__fixed-body-wrapper .el-table__body {
    padding-bottom: 10px;
  }

  .filterContent {
    height: calc(100% - 154px);
    overflow: hidden;
    overflow-y: auto;
  }

  .filterContent::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .filterContent::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
    background: #E1E1E1;
  }

  .filterContent::-webkit-scrollbar-track {
    border-radius: 5px;
    background: #fff;
  }

  .el-table-column--selection {
    text-align: center !important;
  }

  .el-tooltip__popper.is-light {
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    border: 1px solid #E4E7ED !important;
    background-color: #fff;
    color: #000;

    .popper__arrow {
      border-top-color: #E4E7ED;
      border: #E4E7ED;
    }

    .popper__arrow::after {
      border-top-color: #fff;
    }
  }
</style>
